export default "__VITE_ASSET__7872e069__"